import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';

function InfoProveedorPagoHe({ pagoData }) {
    // Formatear la fecha con date-fns
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <Row className='print-flex'>
            <Col md={8} className='print-half'>
                <Table responsive bordered size="sm" className='shadow-none'>
                    <tbody>
                        <tr>
                            <th className='bg-dark-subtle'>Pagado a</th>
                            <td colSpan="3">{pagoData.nomProveedor}</td>
                        </tr>
                        <tr>
                            <th className='bg-dark-subtle'>NIT</th>
                            <td>{pagoData.proveedorID}</td>
                            <th className='bg-dark-subtle'>Teléfono</th>
                            <td>{pagoData.numProveedor}</td>
                        </tr>
                        <tr>
                            <th className='bg-dark-subtle'>Dirección</th>
                            <td>{pagoData.direccion}</td>
                            <th className='bg-dark-subtle'>Ciudad</th>
                            <td>{pagoData.ciudad}</td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
            <Col className='print-half'>
                <Table bordered size="sm" className='shadow-none'>
                    <tbody>
                        <tr>
                            <th className='bg-dark-subtle'>Fecha pago</th>
                            <td>{formatDate(pagoData.fecha)}</td>
                        </tr>
                        <tr>
                            <th className='bg-dark-subtle'>Forma de pago</th>
                            <td>{pagoData.tipoPago}</td>
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    );
}

export default InfoProveedorPagoHe;
